const OVERLAYS_LIST = {
  items: [],
};

export const overlaysListPush = (id) => OVERLAYS_LIST.items.push(id);
export const overlaysListSet = (items) => (OVERLAYS_LIST.items = items ?? []);

export default OVERLAYS_LIST;
